import Vue from 'vue'
import Axios from 'axios'

let user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')) : null;
let token = user !== null ? user.companies !== undefined ? JSON.parse(localStorage.getItem('companytoken')) : JSON.parse(localStorage.getItem('stafftoken')) : null;

Vue.prototype.$auth = {
    user: user,
    token: token
}
